export default __webpack_public_path__ + "static/media/CNo.69-3.89fc4cc1.jpg";